import { useUpdate } from "react-use";
import { useEffect, useMemo } from "react";
import { ChatEvent } from "../store";
import { useSession } from "./useSession";
import { ChatMessageItem } from "../types";

export function useMessage<T extends ChatMessageItem>(
    sessionId: string,
    messageId: string
) {
    const update = useUpdate();
    const { session } = useSession(sessionId);

    const message = useMemo(
        () => session?.chatMessages.find(item => item.guid === messageId),
        [session, messageId]
    );

    useEffect(() => {
        const listener = (data: any) => {
            if (data.id === messageId) update();
        };

        ChatEvent.on("MessageUpdate", listener);

        return () => {
            ChatEvent.off("MessageUpdate", listener);
        };
    }, []);

    return { message: message as T };
}
